import { useMutation } from '@tanstack/react-query';

import type { RemoveAccountRiskRatingOverridePayload } from 'api/RiskAssessmentsApi';
import { RiskAssessmentsApi } from 'api/RiskAssessmentsApi';
import { useFiRiskAssessmentCache } from 'tanstack-hooks/fi-risk-assessments/risk-assessments-cache';
import { ACCOUNT_RISK_PROFILE_KEY } from 'tanstack-hooks/keys';
import { useUser } from 'tanstack-hooks/user';

export function useRemoveAccountRiskRatingOverride() {
  const riskAssessmentsApi = new RiskAssessmentsApi();
  const { userBankId } = useUser();
  const { setAccountRiskProfile } = useFiRiskAssessmentCache();

  const { mutateAsync: removeAccountRiskRatingOverride, isPending: isRemovingAccountRiskRatingOverride } =
    useMutation({
      mutationKey: [ACCOUNT_RISK_PROFILE_KEY, 'removeOverride'],
      mutationFn: ({
        dispensaryId,
        ...data
      }: RemoveAccountRiskRatingOverridePayload & { dispensaryId: string }) =>
        riskAssessmentsApi.removeAccountRiskRatingOverride(userBankId, dispensaryId, data),
      onSuccess: (profile, { dispensaryId }) => {
        setAccountRiskProfile(dispensaryId, profile);
      },
      meta: {
        snackbarSuccessMessage: 'Risk rating override removed.',
        snackbarErrorMessage: 'There was an issue removing the override. Please contact support.'
      }
    });

  return { removeAccountRiskRatingOverride, isRemovingAccountRiskRatingOverride };
}
